export default "__VITE_ASSET__CZG9DXT4__"